module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.9af3b94.woff2";